import { chakra, Heading } from '@chakra-ui/react';

export const StyledHeader = chakra('header', {
  baseStyle: {
    display: 'flex',
    position: 'sticky',
    top: '0',
    alignItems: 'center',
    px: [4, null, 8, 0],
    bgColor: 'white',
    boxShadow: 'inset 0 -1px 0 #CCCCCC',
  },
});

export const StyledHeading = chakra(Heading, {
  baseStyle: {
    mx: [null, null, 4, 8, 10],
    fontSize: ['md', null, 'xl'],
    lineHeight: ['base', null, 1.4, 1.2],
  },
});

export const StyledMenuButton = chakra('button', {
  baseStyle: {
    display: { base: 'flex', lg: 'none' },
    px: { base: '19px', md: '35px' },
    py: 6,
    ml: { base: '-19px', md: '-35px' },
  },
});

export const StyledNavigationItemLabel = chakra('span', {
  baseStyle: {
    fontSize: 'md',
    lineHeight: 'base',
    textTransform: 'capitalize',
  },
});

export const StyledNavigation = chakra('nav', {
  baseStyle: {
    display: 'flex',
    minW: '72px',
    position: { base: 'fixed', lg: 'absolute' },
    left: 0,
    top: { base: 0, lg: '100%' },
    flexDir: 'column',
    w: { base: 'min(100%, 15rem)', lg: 'max-content' },
    h: { base: '100%', lg: 'calc(100vh - 100%)' },
    py: { base: 6, lg: 4 },
    px: { base: 6, lg: 2 },
    overflowY: 'auto',
    overscrollBehaviorY: 'contain',
    bg: 'white',
    zIndex: 1,
    fontSize: '0.875rem',
    lineHeight: 'calc(20/14)',
    // Replacement for borders
    boxShadow: 'inset -1px 0 0 #CCC',
    // Animations
    visibility: { base: 'hidden', lg: 'visible' },
    transform: { base: 'translateX(-110vw)', lg: 'initial' },
    willChange: 'transform',
    transition: { base: 'transform .3s ease, visibility 0s linear .3s', lg: 'initial' },
    '&[aria-expanded="true"]': {
      visibility: 'visible',
      transform: 'translateX(0)',
      transition: 'transform .3s ease',
    },
  },
});

export const StyledLogoContainer = chakra('div', {
  baseStyle: {
    w: [8, null, 10, 12],
    h: [8, null, 10, 12],
    px: [5, null, 4, 3],
    py: [5, null, 4, 3],
    pl: [0, null, 0, 3],
    boxSizing: 'content-box',
  },
});

export const StyledNavLink = chakra('a', {
  baseStyle: {
    display: { lg: 'none' },
    pl: '4.5rem',
    py: '4',
    fontSize: 'md',
    lineHeight: 'base',
    textTransform: 'capitalize',
    textAlign: 'left',
    minH: '3.5rem',
    _hover: {
      fontFamily: 'underline',
    },
  },
});
